module.exports = __webpack_public_path__ + "media/images/universe_landing_pages/hero_banner/component/massage-mobile@2x-e1601245aee98ade25cbc7358ffa2751.jpg";